import { OrderColumns } from 'communication/types/order/Order';
import uniq from 'lodash/uniq';
import State from 'store/State';
import { WidgetInfo } from 'widgets/WidgetInfo';
import { selectAppSettings } from 'app/store/appSettings/selectors';
import { WidgetsService } from 'widgets/WidgetsService';

/*
 * These should match OrderDataRequired
 */
export const requiredStreamingColumns: OrderColumns = [
    'idx',
    'orderID',
    'fillQty',
    'localSymC',
    'isymbol',
    'bloom',
    'cusip',
    'sedol',
    'qty',
    'side',
    'state',
    'tickSize',
];

export function computeRequiredStreamingColumns(
    state: State,
    components: WidgetInfo[],
    widgetsService: WidgetsService
): OrderColumns {
    const streamingColumns = [
        ...requiredStreamingColumns,
        ...getStreamingColumnsForComponents(state, components, widgetsService),
    ];
    return uniq(streamingColumns).sort();
}

function getStreamingColumnsForComponents(
    state: State,
    components: WidgetInfo[],
    widgetsService: WidgetsService
) {
    if (!components) {
        return [];
    }

    const { symbology } = selectAppSettings(state);

    return (
        components
            // for each component
            .reduce((columns: OrderColumns, component: WidgetInfo) => {
                columns.push(
                    ...widgetsService.getRequiredOrderColumns(
                        component.type,
                        state,
                        component.id,
                        symbology
                    )
                );

                // columns may now contain duplicates
                return columns;
            }, [])
    );
}
